/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StatusCountsDTOFromJSON, StatusCountsDTOToJSON, } from './StatusCountsDTO';
/**
 * Check if a given object implements the ScanDataDTO interface.
 */
export function instanceOfScanDataDTO(value) {
    return true;
}
export function ScanDataDTOFromJSON(json) {
    return ScanDataDTOFromJSONTyped(json, false);
}
export function ScanDataDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'keyword': json['keyword'] == null ? undefined : StatusCountsDTOFromJSON(json['keyword']),
        'store': json['store'] == null ? undefined : StatusCountsDTOFromJSON(json['store']),
        'product': json['product'] == null ? undefined : StatusCountsDTOFromJSON(json['product']),
        'restriction': json['restriction'] == null ? undefined : StatusCountsDTOFromJSON(json['restriction']),
    };
}
export function ScanDataDTOToJSON(json) {
    return ScanDataDTOToJSONTyped(json, false);
}
export function ScanDataDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'keyword': StatusCountsDTOToJSON(value['keyword']),
        'store': StatusCountsDTOToJSON(value['store']),
        'product': StatusCountsDTOToJSON(value['product']),
        'restriction': StatusCountsDTOToJSON(value['restriction']),
    };
}
